// Contract ABI for Death Fun smart contract
export const CONTRACT_ABI = [
  {
    inputs: [
      {
        internalType: "string",
        name: "preliminaryGameId",
        type: "string",
      },
    ],
    name: "GameAlreadyExists",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
    ],
    name: "GameDoesNotExist",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
    ],
    name: "GameNotActive",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidServerSignature",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "NotGamePlayer",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PayoutFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "removedAdmin",
        type: "address",
      },
    ],
    name: "AdminRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "autoBuyBack",
        type: "address",
      },
    ],
    name: "AutoBuyBackContractSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ratio",
        type: "uint256",
      },
    ],
    name: "AutoBuyBackParamsSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "player",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "potentialPayoutAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currentRatio",
        type: "uint256",
      },
    ],
    name: "DXFRewardMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DepositReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "preliminaryGameId",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "player",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "betAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "gameSeedHash",
        type: "bytes32",
      },
    ],
    name: "GameCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum DeathFun.GameStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "GameStatusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "PayoutSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "admin",
        type: "address",
      },
    ],
    name: "ReferralPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    inputs: [],
    name: "HALVING_THRESHOLD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "INITIAL_REWARD_RATIO",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_REWARD_MINT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "addAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "autoBuyBack",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "autoBuyBackRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "autoBuyBackThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "potentialPayoutAmount",
        type: "uint256",
      },
    ],
    name: "calculateRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "payoutAmount",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "gameState",
        type: "string",
      },
      {
        internalType: "string",
        name: "gameSeed",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "serverSignature",
        type: "bytes",
      },
    ],
    name: "cashOut",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "onChainGameId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "payoutAmount",
            type: "uint256",
          },
          {
            internalType: "string",
            name: "gameState",
            type: "string",
          },
          {
            internalType: "string",
            name: "gameSeed",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "cashOutDeadline",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "cashOutServerSignature",
            type: "bytes",
          },
          {
            components: [
              {
                internalType: "string",
                name: "preliminaryGameId",
                type: "string",
              },
              {
                internalType: "bytes32",
                name: "gameSeedHash",
                type: "bytes32",
              },
              {
                internalType: "string",
                name: "algoVersion",
                type: "string",
              },
              {
                internalType: "string",
                name: "gameConfig",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "dxfUtilityAmount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "serverSignature",
                type: "bytes",
              },
            ],
            internalType: "struct DeathFun.CreateGameParams",
            name: "newGameParams",
            type: "tuple",
          },
        ],
        internalType: "struct DeathFun.CashOutAndCreateGameParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "cashOutAndCreateGame",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "preliminaryGameId",
            type: "string",
          },
          {
            internalType: "bytes32",
            name: "gameSeedHash",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "algoVersion",
            type: "string",
          },
          {
            internalType: "string",
            name: "gameConfig",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "dxfUtilityAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "serverSignature",
            type: "bytes",
          },
        ],
        internalType: "struct DeathFun.CreateGameParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "createGame",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "dxfToken",
    outputs: [
      {
        internalType: "contract IDXF",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gameCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "games",
    outputs: [
      {
        internalType: "uint256",
        name: "createdAt",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "player",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "betAmount",
        type: "uint256",
      },
      {
        internalType: "enum DeathFun.GameStatus",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "payoutAmount",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "gameSeedHash",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "gameSeed",
        type: "string",
      },
      {
        internalType: "string",
        name: "algoVersion",
        type: "string",
      },
      {
        internalType: "string",
        name: "gameConfig",
        type: "string",
      },
      {
        internalType: "string",
        name: "gameState",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentRewardRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
    ],
    name: "getGameDetails",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "player",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "betAmount",
            type: "uint256",
          },
          {
            internalType: "enum DeathFun.GameStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "payoutAmount",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "gameSeedHash",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "gameSeed",
            type: "string",
          },
          {
            internalType: "string",
            name: "algoVersion",
            type: "string",
          },
          {
            internalType: "string",
            name: "gameConfig",
            type: "string",
          },
          {
            internalType: "string",
            name: "gameState",
            type: "string",
          },
        ],
        internalType: "struct DeathFun.Game",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "preliminaryGameId",
        type: "string",
      },
    ],
    name: "getGameDetailsWithPreliminaryId",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "createdAt",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "player",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "betAmount",
            type: "uint256",
          },
          {
            internalType: "enum DeathFun.GameStatus",
            name: "status",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "payoutAmount",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "gameSeedHash",
            type: "bytes32",
          },
          {
            internalType: "string",
            name: "gameSeed",
            type: "string",
          },
          {
            internalType: "string",
            name: "algoVersion",
            type: "string",
          },
          {
            internalType: "string",
            name: "gameConfig",
            type: "string",
          },
          {
            internalType: "string",
            name: "gameState",
            type: "string",
          },
        ],
        internalType: "struct DeathFun.Game",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "preliminaryGameId",
        type: "string",
      },
    ],
    name: "getOnChainGameId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_messagePrefix",
        type: "string",
      },
      {
        internalType: "address",
        name: "_dxfToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_dxfBuyBack",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "onChainGameId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "gameState",
        type: "string",
      },
      {
        internalType: "string",
        name: "gameSeed",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "potentialPayoutAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "serverSignature",
        type: "bytes",
      },
    ],
    name: "markGameAsLost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "messagePrefix",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "recipient",
        type: "address",
      },
    ],
    name: "payReferral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "preliminaryToOnChainId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "adminToRemove",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_autoBuyBack",
        type: "address",
      },
    ],
    name: "setAutoBuyBackContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_autoBuyBackThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_autoBuyBackRatio",
        type: "uint256",
      },
    ],
    name: "setAutoBuyBackParams",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_dxfToken",
        type: "address",
      },
    ],
    name: "setDXFToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalRewardsMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "recipient",
        type: "address",
      },
    ],
    name: "withdrawFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

// ERC20 ABI for DXF token
export const ERC20_ABI = [
  {
    constant: true,
    inputs: [{ name: "_owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "balance", type: "uint256" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", type: "string" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [],
    name: "name",
    outputs: [{ name: "", type: "string" }],
    type: "function",
  },
  {
    constant: true,
    inputs: [
      { name: "_owner", type: "address" },
      { name: "_spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }],
    type: "function",
  },
  {
    constant: false,
    inputs: [
      { name: "_spender", type: "address" },
      { name: "_value", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }],
    type: "function",
  },
] as const;

// FundRaising Contract ABI
export const FUNDRAISING_CONTRACT_ABI = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "agreementId",
        type: "uint256"
      }
    ],
    name: "getAgreement",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "investor",
            type: "address"
          },
          {
            internalType: "address",
            name: "investTokenAddr",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "investTokenAmount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "dxfTokenAmount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "expiresAt",
            type: "uint256"
          },
          {
            internalType: "uint8",
            name: "status",
            type: "uint8"
          }
        ],
        internalType: "struct FundRaising.Agreement",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "investor",
        type: "address"
      }
    ],
    name: "getAgreementsByInvestor",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "agreementId",
        type: "uint256"
      }
    ],
    name: "invest",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
] as const;
